import { gql } from '@apollo/client/core'

export const USER_MAIL_FRAGMENT = gql`
  fragment UserMailFragment on UserMail {
    id
    idScaneco
    mailType
    createdAt
    dateOfReceipt
    forwardedAt
    physicalLocation
    physicallyDestroyedAt
    processingType
    processingDate
    provisionedAt
    queryDate
    scanFile
    scannedAt
    sendName
    thumbScanFile
    weight
    trackingNumber
    destructionExpectedDate
    parcelForwardable
    hasUserRequest
  }
`

export const PAGINATION_FRAGMENT = gql`
  fragment PaginationFragment on Pagination {
    currentPage
    totalPages
    totalItemsCount
  }
`
